// extracted by mini-css-extract-plugin
export default {"img":"styles_img__s5xeo","description":"styles_description__gm6eo","text":"styles_text__n1EZt"};